<template>
  <div class="base-details-info">
    <Form :label-width="140" v-if="info">
      <Row>
        <FormItem label="教师姓名：" style="width: 33%">
          <div class="flex align-items">
            <span style="margin-right: 10px"> {{ info['teacherName'] }}</span>
            <Tag color="magenta" v-if="info['departure'] == 1">已离职</Tag>
          </div>
        </FormItem>
        <FormItem label="性别：" style="width: 33%"
          >{{ getGenderStr(info['gender']) }}
        </FormItem>
        <FormItem label="手机号码：" style="width: 33%"
          >{{ info['phoneNo'] }}
        </FormItem>
      </Row>
      <Row>
        <FormItem label="所属学校/机构：" style="width: 33%"
          >{{ info['orgName'] }}
        </FormItem>
        <FormItem label="身份证件号码：" style="width: 33%"
          >{{ info['identityNo'] }}
        </FormItem>
        <FormItem label="老师类型：" style="width: 33%"
          >{{ getTeacherTypeStr(info['teacherType']) }}
        </FormItem>
      </Row>
    </Form>
  </div>
</template>

<script>
import mixin from '../../mixins'
export default {
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  mixins: [mixin],
}
</script>

<style lang="scss" scoped>
.base-details-info {
  /deep/ .ivu-form-item {
    margin-bottom: 6px !important;
  }
}
</style>